import React from 'react';
import { Row, Col, Button } from 'antd';
import { FacebookFilled, TwitterSquareFilled, LinkedinFilled, YoutubeFilled, GooglePlusSquareFilled } from '@ant-design/icons';
import { BASE_URL } from '../constants/Url';
import { useTranslation } from 'react-i18next';

const SchoolCommunity = () => {
  const { t } = useTranslation();
  const community = {
    image: "/about-us/social.jpg", // Replace with actual image path
  };
  return (
    <div
      style={{
        backgroundImage: `url(${BASE_URL + community.image})`, // Replace with your background image URL
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '180px 20px',
        color: '#fff',
        textAlign: 'center',
        position: 'relative',
        marginTop: "60px"
      }}
    >
      {/* Orange overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: "linear-gradient(rgba(241, 97, 138, 0.13), rgba(17, 152, 17, 0.7))",
          zIndex: 1,
        }}
      ></div>

      {/* Content */}
      <div style={{ position: 'relative', zIndex: 2 }}>
        <h2 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '16px' }}>{t("ប្រវត្តិសូងខ្មែរ")}</h2>
        <p style={{ fontSize: '18px', marginBottom: '40px', lineHeight:"2rem" }}>{t(" សូងខ្មែរ គឺជាប្រភេទស្រូវដែលត្រូវបានដាំដុះនៅក្នុងប្រទេសកម្ពុជា ចាប់តាំងពីសម័យបុរាណ។ សូងនេះមានតួនាទីសំខាន់ក្នុងជីវភាពប្រចាំថ្ងៃរបស់ប្រជាជនខ្មែរ ព្រោះវាជាផលិតផលសំខាន់សម្រាប់ប្រើធ្វើម្ហូបបរិច្ឆេទ និងការទទួលទានប្រចាំថ្ងៃ។ ក្នុងប្រវត្តិសាស្រ្ត ការដាំស្រូវសូងត្រូវបានបង្កើតឡើងតាមបែបប្រពៃណីជាច្រើនជាន់ជាប់ ហើយបានបន្តអភិវឌ្ឍន៍យ៉ាងច្រើននៅក្នុងតំបន់មេគង្គ និងកម្ពុជា។ សូងខ្មែរបានប្រើប្រាស់វិធីសាស្រ្តដាំដុះប្រពៃណី ដោយផ្អែកលើការបង្កើតសួនចម្ការនិងប្រព័ន្ធទឹកជ្រៅ ដើម្បីធានាការបញ្ចេញផលចំរូងដែលមានគុណភាពល្អ។ សូងខ្មែរមានមុខងារច្រើននៅក្នុងសេដ្ឋកិច្ចកសិកម្ម ជាពិសេសសម្រាប់គ្រួសារក្នុងតំបន់ជនបទដែលមានការពឹងផ្អែកលើការដាំស្រូវជាផលចម្បងក្នុងការរស់រានមានជីវិត។")}</p>

        {/* Social Icons */}
        {/* <Row justify="center" gutter={16}>
          <Col>
            <Button
              shape="circle"
              size="large"
              icon={<FacebookFilled />}
              style={{ backgroundColor: '#4267B2', color: '#fff', fontSize: '20px' }}
            />
          </Col>
          <Col>
            <Button
              shape="circle"
              size="large"
              icon={<TwitterSquareFilled />}
              style={{ backgroundColor: '#1DA1F2', color: '#fff', fontSize: '20px' }}
            />
          </Col>
          <Col>
            <Button
              shape="circle"
              size="large"
              icon={<LinkedinFilled />}
              style={{ backgroundColor: '#0077B5', color: '#fff', fontSize: '20px' }}
            />
          </Col>
          <Col>
            <Button
              shape="circle"
              size="large"
              icon={<YoutubeFilled />}
              style={{ backgroundColor: '#FF0000', color: '#fff', fontSize: '20px' }}
            />
          </Col>
          <Col>
            <Button
              shape="circle"
              size="large"
              icon={<GooglePlusSquareFilled />}
              style={{ backgroundColor: '#DB4437', color: '#fff', fontSize: '20px' }}
            />
          </Col>
        </Row> */}
      </div>
    </div>
  );
};

export default SchoolCommunity;
